import Vue from 'vue'
import router from '../router'
import http from '../http'
import * as Types from './types'

export default {
    setCompany({ commit }, payload) {
        commit(Types.SET_COMPANY_SELECTED, payload)
    },

    async signIn({ commit, state }, auth) {
        commit(Types.REQUEST_LOGIN)

        try {
            const { token, user } = (await http.post('sessao', auth)).data

            if (user.empresas.length < 1) {
                Vue.toasted.global.error({
                    message: 'Seu usuário não possui empresas associadas'
                })

                throw new Error('Usuário sem empresas associadas')
            }

            commit(Types.SET_COMPANY_SELECTED, user.empresas[0])

            return commit(Types.SUCCESS_LOGIN, {
                token,
                user: { ...user, email: auth.email }
            })
        } catch (e) {
            console.log(e)
            commit(Types.FAILURE_LOGIN)

            throw new Error('Login Failure')
        }
    },

    signOut({ commit, state }) {
        localStorage.setItem('@fluid/lastLogin', state.auth.user.email)
        localStorage.setItem('@fluid/keep', false)

        commit(Types.REQUEST_LOGOUT)

        router.push('/login')
    },

    toggleLoading({ commit }, payload) {
        commit(Types.APP_LOADING)
    }
}
